// TODO: remove eslint disable
/* eslint-disable */
import { get, post, remove, put, getForDownload, patch } from "../base";
import store from "../../store";
import * as actions from "../../store/actions/crm";

const companiesUrl = "api/crm/companies";
const companyDetailsUrl = id => `api/crm/companies/${id}`;
const paymentInfoUrl = "api/crm/payment-info";
const getStaffUrl = "api/crm/staff";
const editPaymentUrl = id => `${paymentInfoUrl}/${id}`;
const categoriesUrl = "api/crm/categories";
const countriesUrl = "api/crm/countries";
const countryDataSetsUrl = "api/crm/country-datasets";
const subscriptionUrl = "api/crm/subscription";
const editSubscriptionUrl = id => `${subscriptionUrl}/${id}`;
const addUserUrl = id => `api/crm/companies/${id}/add-user`;

const { dispatch } = store;

export const getCompanies = async () => {
  try {
    dispatch(actions.getCompanies());
    const response = await get(companiesUrl);
    dispatch(actions.getCompaniesSucceed(response));
  } catch (error) {
    console.warn("getCompanies catch", error);
    dispatch(actions.getCompaniesFailed(error));
  }
};

export const getCompany = async id => {
  try {
    dispatch(actions.getCompany());
    const response = await get(companyDetailsUrl(id));
    dispatch(actions.getCompanySucceed(response));
  } catch (error) {
    console.warn("getCompany catch", error);
    dispatch(actions.getCompanyFailed(error));
  }
};

export const getStaff = async () => {
  try {
    dispatch(actions.getStaff());
    const response = await get(getStaffUrl);
    dispatch(actions.getStaffSucceed(response));
  } catch (error) {
    dispatch(
      actions.getStaffFailed(error.response && error.response.data) || error
    );
  }
};

export const createCompany = async ({ name, country }) => {
  try {
    dispatch(actions.updateSelectedCompany());
    const response = await post(`${companiesUrl}`, { name, country });
    dispatch(actions.updateSelectedCompanySucceed(response));
  } catch (error) {
    dispatch(
      actions.updateSelectedCompanyFailed(
        error.response && error.response.data
      ) || error
    );
  }
};

export const getAudienceActivity = async ({ id, dates }) => {
  try {
    dispatch(
      actions.getAudienceActivity({
        isDownloaded: true,
        errors: null,
        isActivityLoading: true
      })
    );
    const response = await getForDownload(
      `/api/crm/export-audience-activity?company_id=${id ||
        ""}&start_date=${dates?.startDate || ""}&end_date=${dates?.endDate ||
        ""}`
    );
    dispatch(
      actions.getAudienceActivitySucceed({
        data: response.data,
        isDownloaded: true,
        errors: null,
        isActivityLoading: false,
        fileName: response.headers["content-disposition"].split('"')[1]
      })
    );
  } catch (error) {
    dispatch(
      actions.getAudienceActivityFailed(
        error.response && error.response.data
      ) || error
    );
  }
};

export const getCountries = async () => {
  try {
    dispatch(actions.getCountries());
    const response = await get(countriesUrl);
    dispatch(actions.getCountriesSucceed(response));
  } catch (error) {
    console.warn("getCompanies catch", error);
    dispatch(actions.getCountriesFailed(error));
  }
};

export const createPaymentInfo = async data => {
  try {
    dispatch(actions.createPaymentInfo());
    const response = await post(paymentInfoUrl, data);
    dispatch(actions.createPaymentInfoSucceed(response));
  } catch (error) {
    dispatch(
      actions.createPaymentInfoFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const getCategories = async () => {
  try {
    dispatch(actions.getCategories());
    const response = await get(categoriesUrl);
    dispatch(actions.getCategoriesSucceed(response));
  } catch (error) {
    dispatch(
      actions.getCategoriesFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const getCountryDatasets = async () => {
  try {
    dispatch(actions.getCountryDatasets());
    const response = await get(countryDataSetsUrl);
    dispatch(actions.getCountryDatasetsSucceed(response));
  } catch (error) {
    dispatch(
      actions.getCountryDatasetsFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const createSubscription = async data => {
  try {
    dispatch(actions.createSubscription());
    const response = await post(subscriptionUrl, data);
    dispatch(actions.createSubscriptionSucceed(response));
  } catch (error) {
    dispatch(
      actions.createSubscriptionFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const addCompanyUser = async (data, id) => {
  try {
    dispatch(actions.inviteCompanyUser());
    const response = await post(addUserUrl(id), data);
    dispatch(
      actions.inviteCompanyUserSucceed({
        ...data,
        ...response
      })
    );
  } catch (error) {
    dispatch(
      actions.inviteCompanyUserFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const editCompanyInfo = async (data, id) => {
  try {
    dispatch(actions.updateSelectedCompany());
    const response = await put(companyDetailsUrl(id), data);
    dispatch(actions.updateSelectedCompanySucceed(response));
  } catch (error) {
    dispatch(
      actions.updateSelectedCompanyFailed(
        error.response && error.response.data
      ) || error
    );
  }
};

export const editCompanyInfoOwner = async (data, id) => {
  try {
    dispatch(actions.updateSelectedCompany());
    const response = await patch(companyDetailsUrl(id), data);
    dispatch(actions.updateSelectedCompanySucceed(response));
  } catch (error) {
    dispatch(
      actions.updateSelectedCompanyFailed(
        error.response && error.response.data
      ) || error
    );
  }
};

export const editCompanyPaymentIndo = async (data, id) => {
  try {
    dispatch(actions.createPaymentInfo());
    const response = await put(editPaymentUrl(id), data);
    dispatch(actions.createPaymentInfoSucceed(response));
  } catch (error) {
    dispatch(
      actions.createPaymentInfoFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const editCompanySubscription = async (data, id) => {
  try {
    dispatch(actions.createSubscription());
    const response = await put(editSubscriptionUrl(id), data);
    dispatch(actions.createSubscriptionSucceed(response));
  } catch (error) {
    dispatch(
      actions.createSubscriptionFailed(error.response && error.response.data) ||
        error
    );
  }
};

export const removeUser = async id => {
  try {
    const response = await remove(`api/crm/userprofiles/${id}`);
    dispatch(actions.removeCompanyUser(id));
  } catch (err) {
    console.log(err);
  }
};

export const removeCompany = async id => {
  try {
    dispatch(actions.removeCompany());
    await remove(companyDetailsUrl(id));
    dispatch(actions.removeCompanySucceed(id));
  } catch (e) {
    dispatch(
      actions.removeCompanyFailed(error.response && error.response.data) ||
        error
    );
  }
};
